/**
 * Copyright (c) 2020 Siemens Inc.
 * Unpublished - All rights reserved
 * 
 */
import axios from 'axios';

const BASE_URL = '/api/licensing';

async function decodeLicensingFile(licensingFormData, onLoadProgress) {
    return axios.post(BASE_URL, licensingFormData, {
        onUploadProgress: ProgressEvent => {
            onLoadProgress((ProgressEvent.loaded / ProgressEvent.total*100));
        } 
    });
}

export {
    decodeLicensingFile
}